import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

function useSuperAdminInvoices() {
  return useQuery({
    queryKey: ["superadmin", "invoices"],
    // El endpoint pagina ({count, results}); la página consume el array plano.
    queryFn: () =>
      apiClient
        .get("/api/v1/superadmin/invoices/")
        .then((r) => r.data?.results ?? r.data),
  });
}

export { useSuperAdminInvoices };
